module.exports = __webpack_public_path__ + "static/media/logo-boxmi-header-mobile.ffbb5037.svg";